import { render } from "./sources.vue?vue&type=template&id=f80f953c"
import script from "./sources.vue?vue&type=script&lang=js"
export * from "./sources.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__